import { createSvgIcon } from "@mui/material";

export const RemovePathPointIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 24" fill="currentColor">
        <polygon points="5.4,20.2 6.1,20.6 13.8,14 13.9,10.1 7.9,6.7 4.7,8.9 3.2,18.9 3.9,19.2 8.5,11 10,11.8 		" />
        <rect x="10.5" y="2.7" transform="matrix(0.486 -0.874 0.874 0.486 0.9082 13.7807)" width="3.4" height="6.9" />
        <path d="M-1.5,12.6" />
        <rect x="14" y="17" width="8" height="2" />
    </svg>,
    "RemovePathPoint"
);
